import { observer } from 'mobx-react-lite';
import { LayoutChangeEvent, View } from 'react-native';
import { style } from './BottomBarEdit.style';
import { useStore } from 'src/contexts/StoreContext';
import { ProductModelInstance } from 'src/store/_models/product';
import { SliderRotation } from '../tools/slider-rotation/SliderRotation';
import { neutrals } from 'src/theme/colors';
import { ACTIVE_TOOLS } from 'src/store/page-project/pageProject.constants';
import { EditLookupToolbar } from '../toolbars/edit-lookup-toolbar/EditLookupToolbar';
import { BottomSheetAdjustments } from '../bottom-sheet-adjustments/BottomSheetAdjustments';
import { BottomSheetOrientation } from '../bottom-sheet-orientation/BottomSheetOrientation';
import { BottomSheetFilters } from '../bottom-sheet-filters/BottomSheetFilters';
import { useEffect } from 'react';
import { useRoute } from '@react-navigation/native';
import { ROUTE_NAMES } from 'src/routes/_shared/routes.constants';
import { BottomBarEditSaveButton } from './bottom-bar-edit-save-button/BottomBarEditSaveButton';

const Tool = ({ tool }: { tool: ACTIVE_TOOLS }) => {
  let Component = () => <></>;
  switch (tool) {
    case ACTIVE_TOOLS.adjustments:
      Component = BottomSheetAdjustments;
      break;
    case ACTIVE_TOOLS.orientation:
      Component = BottomSheetOrientation;
      break;
    case ACTIVE_TOOLS.filters:
      Component = BottomSheetFilters;
      break;
  }
  return <Component justContent={true} />;
};

export const BottomBarEdit = observer(
  ({ activeProduct, isVisible = true }: { activeProduct: ProductModelInstance; isVisible?: boolean }) => {
    const { project } = useStore();
    const route = useRoute();
    const isSaveButtonVisible = route?.name !== ROUTE_NAMES.Edit;

    const onLayoutHandler = (e: LayoutChangeEvent) => {
      project.setBottomSheetLookupHeight(e.nativeEvent.layout.height);
    };

    useEffect(() => {
      return () => project.setBottomSheetLookupHeight(0);
    }, []);

    return (
      <View style={style.container} onLayout={onLayoutHandler}>
        {project.activeTool === ACTIVE_TOOLS.frame ? (
          <View>
            <View style={style.sliderWrapper}>
              <SliderRotation gradientColor={neutrals.white} />
            </View>
            <View style={style.mainContent}>
              <EditLookupToolbar
                activeProduct={activeProduct}
                onOpenTool={async tool => project.setActiveTool(tool.code as ACTIVE_TOOLS)}
                isVisible={isVisible}
              />
              {/* TODO: Removed this button in v3  */}
              {isSaveButtonVisible && <BottomBarEditSaveButton activeProduct={activeProduct} />}
            </View>
          </View>
        ) : (
          <Tool tool={project.activeTool} />
        )}
      </View>
    );
  },
);

BottomBarEdit.displayName = 'BottomBarEdit';
